import { ClipboardList, DollarSign, FileText, FolderOpen, LayoutDashboard, UserRound } from "lucide-react";
import { cn } from "@/lib/cn";

export type AbaDoCadastro = "visao" | "pedidos" | "extrato" | "precos" | "dados" | "arquivos";

export const ABAS_DO_CADASTRO: Record<AbaDoCadastro, { rotulo: string; icone: typeof FileText }> = {
  visao: { rotulo: "Visão geral", icone: LayoutDashboard },
  pedidos: { rotulo: "Pedidos", icone: ClipboardList },
  extrato: { rotulo: "Extrato", icone: FileText },
  precos: { rotulo: "Preços", icone: DollarSign },
  dados: { rotulo: "Dados", icone: UserRound },
  arquivos: { rotulo: "Arquivos", icone: FolderOpen },
};

/** Barra de abas sublinhada, como a da ficha do paciente; no celular rola de lado. */
export function AbasDoCadastro({ abas, ativa, onAba }: { abas: AbaDoCadastro[]; ativa: AbaDoCadastro; onAba: (a: AbaDoCadastro) => void }) {
  return (
    // `overflow-x-auto` torna o eixo y rolável também, e o `-mb-px` das abas passava 1px: aparecia a
    // barra vertical com setas. A linha cinza virou sombra interna (a aba ativa pinta por cima dela) e
    // nada passa da altura; rola de lado no dedo, sem barra.
    <div role="tablist" className="scrollbar-hide flex gap-1 overflow-x-auto overflow-y-hidden shadow-[inset_0_-1px_0_0_theme(colors.zinc.200)] dark:shadow-[inset_0_-1px_0_0_hsl(var(--border))]">
      {abas.map((a) => {
        const { rotulo, icone: Icone } = ABAS_DO_CADASTRO[a];
        return (
          <button
            key={a}
            type="button"
            role="tab"
            aria-selected={ativa === a}
            onClick={() => onAba(a)}
            className={cn(
              "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap border-b-2 px-3 py-2.5 text-[13px] font-medium transition-colors",
              ativa === a
                ? "border-brand-600 font-semibold text-brand-700 dark:border-primary dark:text-primary"
                : "border-transparent text-zinc-500 hover:text-zinc-800 dark:text-muted-foreground dark:hover:text-foreground",
            )}
          >
            <Icone className="h-4 w-4" />
            {rotulo}
          </button>
        );
      })}
    </div>
  );
}
